var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58.301,
    height: 58.301,
    viewBox: "0 0 58.301 58.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_232",
    x: 0,
    y: 0,
    width: 58.301,
    height: 58.301,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13229",
    "data-name": "Group 13229",
    transform: "translate(5071.65 -823.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5071.65, 823.35)",
    filter: "url(#Ellipse_232)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_232-2",
    "data-name": "Ellipse 232",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(9.15 6.15)",
    fill: "#fff",
    stroke: "rgba(59,89,153,0.5)",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "google",
    transform: "translate(-5049.5 842.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27755",
    "data-name": "Path 27755",
    d: "M46.908,299.549a6.922,6.922,0,0,1-10.508-1.78l.455-2.1,2.015-.374a3.718,3.718,0,0,0,3.536,2.617,3.638,3.638,0,0,0,2.166-.706l1.936.3Z",
    transform: "translate(-35.405 -287.225)",
    fill: "#59c36a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27756",
    "data-name": "Path 27756",
    d: "M260.5,367.538l-.4-2.043-1.936-.3a3.638,3.638,0,0,1-2.166.706v3.309A6.989,6.989,0,0,0,260.5,367.538Z",
    transform: "translate(-249 -355.214)",
    fill: "#00a66c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Connected_Home_1_",
    transform: "translate(0 3.456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13227",
    "data-name": "Group 13227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13226",
    "data-name": "Group 13226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13225",
    "data-name": "Group 13225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27757",
    "data-name": "Path 27757",
    d: "M3.309,129.944a3.823,3.823,0,0,0,.156,1.075L1,133.487A6.806,6.806,0,0,1,1,126.4l1.982.341.487,2.128A3.822,3.822,0,0,0,3.309,129.944Z",
    transform: "translate(0 -126.4)",
    fill: "#ffda2d"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_27758",
    "data-name": "Path 27758",
    d: "M248.41,197.641a6.989,6.989,0,0,1-2.5,5.324l-2.338-2.338a3.63,3.63,0,0,0,1.14-1.345H241.41a.406.406,0,0,1-.41-.41V196.41a.406.406,0,0,1,.41-.41h6.475a.405.405,0,0,1,.4.336A6.956,6.956,0,0,1,248.41,197.641Z",
    transform: "translate(-234.41 -190.641)",
    fill: "#4086f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27759",
    "data-name": "Path 27759",
    d: "M259.306,199.281a3.631,3.631,0,0,1-1.14,1.345l2.338,2.338a6.933,6.933,0,0,0,2.373-6.628.405.405,0,0,0-.4-.336H256v3.281Z",
    transform: "translate(-249 -190.641)",
    fill: "#4175df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27760",
    "data-name": "Path 27760",
    d: "M47.023,1.955a.414.414,0,0,1-.115.3L45.153,4.006a.4.4,0,0,1-.533.041A3.669,3.669,0,0,0,42.4,3.309a3.717,3.717,0,0,0-3.536,2.617L36.4,3.456a6.918,6.918,0,0,1,10.475-1.8.431.431,0,0,1,.148.3Z",
    transform: "translate(-35.405 0)",
    fill: "#ff641a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27761",
    "data-name": "Path 27761",
    d: "M258.215,4.047a.4.4,0,0,0,.533-.041L260.5,2.259a.414.414,0,0,0,.115-.3.431.431,0,0,0-.148-.3A6.979,6.979,0,0,0,256,0V3.309A3.669,3.669,0,0,1,258.215,4.047Z",
    transform: "translate(-249 0)",
    fill: "#f03800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleicon);
export default __webpack_public_path__ + "static/media/googleicon.fdc24e53b8960ba09ed5312b788fa22e.svg";
export { ForwardRef as ReactComponent };